import _ from 'lodash';

import { ICondition, isInstanceOfCondition } from './ICondition';

export interface IConditionGroup {
  and?: IConditionGroup[] | ICondition[];
  or?: IConditionGroup[] | ICondition[];
}

/**
 * Verify that the given @param object is of type IConditionGroup
 *
 * @param {any} object The object to test
 * @return {boolean} True if the @param object is of type IConditionGroup
 */
export const isInstanceOfConditionGroup = (object: any): boolean => {
  const values = _.get(object, 'and') || _.get(object, 'or');
  return Array.isArray(values) && values.every((v) => isInstanceOfConditionGroup(v) || isInstanceOfCondition(v));
};
